import {RegulationStandardTimeFormatter} from "./regulation-standard-time-formatter";

export abstract class RegulationUSTimeFormatter extends RegulationStandardTimeFormatter {

    protected abstract _getTimeZone(): string;

    formatClock(): string {
        const options: Intl.DateTimeFormatOptions = {
            timeZone: this._getTimeZone(),
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        };

        return new Intl.DateTimeFormat('en-US', options).format(this.services.time.getCurrentDate());
    }

    formatLocalDateWithFullTime(localDate: Date): string {
        const options: Intl.DateTimeFormatOptions = {
            timeZone: this._getTimeZone(),
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        };

        return new Intl.DateTimeFormat('en-US', options).format(localDate).replace(/,/, '');
    }
}